<template>
    <div class="message-header">
        <section class="avatar-section">
            <AppImage
				class="avatar"
				title="avatar"
				:src="avatar"
                :fallback="require('@/assets/img/default-avatar.png')"
			/>
        </section>

        <section class="details-section">
            <p class="sender">{{ sender }}</p>
            <p class="email">{{ senderEmail }}</p>
        </section>

        <section
			class="date-section"
			v-if="messageDate && messageTime"
		>
            <span>{{ messageDate | dateFormatter('MMM D, YYYY') }}&nbsp;</span>
            <span>{{ messageTime | time('HH:mm') }}</span>
        </section>
    </div>
</template>

<script>
export default {
	props: {
		avatar: {
			type: String
		},

		messageDate: {
			type: String,
			required: true
		},

		messageTime: {
			type: String,
			required: true
		},

		sender: {
			type: String,
			default: 'Upmood Admin'
		},

		senderEmail: {
			type: String,
			default: 'admin@upmood.com'
		}
	},

	computed: {
		emailSubject () {
			return this.subject.split('_').join(' ')
		}
	}
}
</script>

<style lang="scss" scoped>
.message-header {
	display: flex;
	width: 100%;

    .avatar-section {
        margin-right: 1em;

        .avatar {
            width: 2.5em;
            height: 2.5em;
			border-radius: 50%;
			background-size: cover;
        }
    }

    .details-section {
        flex: 1 1 auto;
        margin-right: 20px;

		.sender {
			margin-bottom: .5em;
			color: lighten($default, 7%);
		}

		.email {
			font-size: .8em;
			color: $default-light;
		}
    }

    .date-section {
        text-align: right;
		font-size: .8em;
		color: $default-light;
		flex-shrink: 0;
    }
}
</style>
